import { initAndGetAnalyticsSdk } from '@mmt/event-logger';
import {
  generateJourneyId,
  getDeviceContext,
  getGlobalData,
  getJourneyId,
  getPdtRequestId,
  getRequestId,
  getSubPageName,
  getUserContext,
  PDT_REQUEST_ID,
} from './analytics-utils';
import { LOB, SUB_LOB, TEMPLATE_ID, TOPIC_NAME } from './analytics-constants';
import { getCmpDetails } from '../client/common/src/utils/utils';
import { getAffiliate } from '../client/common/utils/appUtils';
import { getUrlParamsMapV2 } from '../client/common/utils/browserUtils';
import { getCookie } from '../client/common/service/cookieService';

let page_name = '';
let page_version = '';

const DEFAULT_SEARCH_CONTEXT = {
  to: {
    locus: {
      locus_id: '',
      locus_type: '',
      country: '',
      locus_v2_id: '',
      locus_v2_type: '',
    },
    locus_v2: {
      locus_id: '',
      locus_type: '',
      country: '',
    },
    location: {
      code: '',
      name: '',
      type: '',
      country: '',
      country_code: '',
    },
  },
  from: {
    locus: {
      locus_id: '',
      locus_type: '',
      country: '',
      locus_v2_id: '',
      locus_v2_type: '',
    },
    locus_v2: {
      locus_id: '',
      locus_type: '',
      country: '',
    },
    location: {
      code: '',
      name: '',
      type: '',
      country: '',
      country_code: '',
    },
  },
};

export const init = (pageName, version) => {
  if (pageName) {
    page_name = pageName;
  }
  if (version) {
    page_version = version;
  }
  if (window) {
    if (!window.AnalyticsSdk) {
      window.AnalyticsSdk = initAndGetAnalyticsSdk({
        // This is commented, there will be changes from common side, besides replacing they have to merge the object
        // runtimeContextProvider: {
        //   getUserContext,
        //   getDeviceContext,
        // },
      });
    }
    return window.AnalyticsSdk;
  }
  return initAndGetAnalyticsSdk({
    // runtimeContextProvider: {
    //   getUserContext,
    //   getDeviceContext,
    // },
  });
};

export const captureEvent = (eventDetails, needNewJourneyId, addon) => {
  const sdk = init();
  const trackingCookie = getCookie('track');
  const {
    lob_category,
    search_context,
    error_details_list,
    previous_page,
    experiment_details,
    event_detail = {},
    pageContextPageType = '',
  } = getGlobalData();
  const eventLogger = {
    page_context: {
      lob: LOB,
      lob_category,
      // sub_lob: SUB_LOB,
      page_name,
      page_type: pageContextPageType,
      subpage_name: getSubPageName(),
      funnel_step: page_name,
      page_url: window.location.href,
      prev_page_name: previous_page,
      travel_store: {
        store_id: null,
      },
    },
    campaign_details: {
      campaign_name: getCmpDetails()?.cmp,
      campaign_key: getCmpDetails()?.cmp,
    },
    event_detail: {
      page_version,
      message_type: trackingCookie ? 'adobe_cookie' : null,
      ...event_detail,
      ...eventDetails,
    },
    event_tracking_context: {
      topic_name: TOPIC_NAME,
      template_id: TEMPLATE_ID,
      request_id: getRequestId(),
      affiliate_id: getAffiliate(),
      [PDT_REQUEST_ID]: [getPdtRequestId()],
      env: 'prod',
      time_zone: 'Asia/Calcutta',
      journey_id: needNewJourneyId ? generateJourneyId() : getJourneyId(),
      organisation: 'MMT',
      bu: 'holidays',
      funnel_source: 'mmt',
      funnel_entry:
        getUrlParamsMapV2()?.quoteRequestId || getUrlParamsMapV2()?.psmQID ? 'PSM' : 'Online',
    },
    search_context: search_context || DEFAULT_SEARCH_CONTEXT,
    error_details_list,
    experiment_details,
    ...(addon && {
      addon_details: [...addon],
    }),
  };

  if (trackingCookie === 'true') {
    sdk.pushToAdobeDataLayer(eventLogger, { lob: 'holiday', destinationUrl: '' });
  } else {
    sdk.track(eventLogger, 'holiday');
  }
};
